import { render } from "./Bazaar.vue?vue&type=template&id=07b9676a&scoped=true"
import script from "./Bazaar.vue?vue&type=script&lang=js"
export * from "./Bazaar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-07b9676a"

export default script